import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpiralHeatExchanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 95,
	viewBox: "0 0 100.0 95.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 50,
			rx: 45,
			ry: 45,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 50,
			rx: 35,
			ry: 35,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 60,
			cy: 50,
			rx: 3,
			ry: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40,
			cy: 50,
			rx: 3,
			ry: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 50.0 L 40.0 50.0 M 0.0 45.0 L 0.0 55.0 M 60.0 50.0 L 100.0 50.0 M 100.0 45.0 L 100.0 55.0 M 70.0 0.0 L 80.0 0.0 M 20.0 0.0 L 30.0 0.0 M 25.0 0.0 L 25.0 20.0 L 38.0 48.0 M 75.0 0.0 L 75.0 20.0 L 62.0 48.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgSpiralHeatExchanger;
